const articleGrid = () => {
    const attachEventListeners = (section) => {
        section.addEventListener('click', async (event) => {
            const target = event.target;
            if (target.matches('[data-load-more]')) {
                const url = target.getAttribute('data-load-more');
                target.classList.add('article-grid__load-more-button--loading');
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.text();
                    const parser = new DOMParser();
                    const newDoc = parser.parseFromString(data, 'text/html');
                    const newArticles = newDoc.getElementById('article-grid__articles').innerHTML;
                    const articleGridInner = section.querySelector('.article-grid__inner');
                    if (articleGridInner) {
                        articleGridInner.innerHTML += newArticles;
                    }
                    target.parentElement?.remove();
                    const nextPageButton = newDoc.querySelector('[data-load-more]');
                    if (nextPageButton) {
                        const buttonContainer = newDoc.querySelector('.article-grid__button-container');
                        if (buttonContainer) {
                            section.appendChild(buttonContainer);
                        }
                    }
                }
                catch (error) {
                    console.error('Error fetching more articles:', error);
                }
            }
        });
    };
    // Attach event listeners to existing [data-article-grid] elements
    const articleGridSections = document.querySelectorAll('[data-article-grid]');
    articleGridSections.forEach(attachEventListeners);
    // Create a MutationObserver instance
    const observerSection = document.querySelector('.shopify-section--article-grid');
    const observerConfig = { attributes: true, childList: true, subtree: true };
    const observerCallback = () => {
        const articleGridSections = document.querySelectorAll('[data-article-grid]');
        articleGridSections.forEach(attachEventListeners);
    };
    const observer = new MutationObserver(observerCallback);
    // Start observing changes in the document's body
    if (observerSection) {
        observer.observe(observerSection, observerConfig);
    }
};
export { articleGrid };
